module.exports = __webpack_public_path__ + "static/media/whitelogo.00142f6c.png";